import { ClockIcon } from "lucide-react";
import { Input } from "@/components/ui/input";

export type TimePickerProps = {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
  id?: string;
};

export function TimePicker({
  value,
  onChange,
  disabled = false,
  className,
  id,
}: TimePickerProps) {
  return (
    <div className="relative">
      <Input
        id={id}
        type="time"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={`bg-background appearance-none [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none ${className}`}
      />
      <ClockIcon className="absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground pointer-events-none" />
    </div>
  );
}

export default TimePicker;
